import { RouteType } from "../../router/enums";
import { MainRoute, Route } from "../../router/types";

export function isMainRoute(route: Route): route is MainRoute {
  return "type" in route && route.type === RouteType.MAIN_ROUTE;
}
